'use client';

import { c as _c } from "react/compiler-runtime";
import { ControlBarMoreAction, ControlBarReportAction } from '@/app/[locale]/(worlds)/[roomId]/components/ControlBarActions';
import type { ControlBarViewportLayoutProps } from '@/app/[locale]/(worlds)/[roomId]/components/ControlBarViewportLayout';
import Full3dExitButton from '@/app/[locale]/(worlds)/[roomId]/components/Full3dExitButton';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useUAContext } from '@/context/UAContext';
import type { RecommendRoom } from '@/services/cms';
type ControlBarMobileViewportOptions = {
  isMobileLandscape: boolean;
  moreRecommendationsPromise?: Promise<RecommendRoom[]> | null;
};
export function MobileControlBar(t0) {
  const $ = _c(21);
  const {
    moreRecommendationsPromise,
    popupContainer
  } = t0;
  const {
    isMobileLandscape
  } = useUAContext();
  const {
    roomData
  } = useCheckEnterRoomContext();
  const contentKind = roomData.content_type?.code === "games" ? "games" : "experiences";
  const t1 = isMobileLandscape ? "landscape" : "portrait";
  const t2 = isMobileLandscape ? "z-floating bg-vive-primary-80/80 flex h-full w-[60px] shrink-0 flex-col justify-between pt-1 pr-2 pb-[max(4px,env(safe-area-inset-bottom))] pl-7 backdrop-blur-2xl" : "z-floating bg-vive-primary-80/80 flex h-[34px] w-full shrink-0 items-center justify-between px-9 py-1 backdrop-blur-2xl";
  const t3 = isMobileLandscape ? "flex flex-col items-center gap-3" : "flex w-[191px] items-center gap-3";
  const t4 = `${isMobileLandscape ? "-rotate-90" : ""} size-3.5 text-vive-primary-20`;
  let t5;
  if ($[0] !== popupContainer || $[1] !== t4) {
    t5 = <Full3dExitButton className="z-floating relative" buttonClassName="flex size-6 shrink-0 items-center justify-center rounded-full bg-white/15 p-1 backdrop-blur-[50px]" dialogContainer={popupContainer} dialogPresentation="mobile-control-bar" iconClassName={t4} />;
    $[0] = popupContainer;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = isMobileLandscape ? "flex h-11 w-6 items-center justify-center" : "inline-flex shrink-0";
  const t7 = isMobileLandscape ? "h-6 w-11 -rotate-90 border px-1 py-1 text-[10px]" : "h-6 w-11 border px-1 py-1 text-[10px]";
  let t8;
  if ($[3] !== contentKind || $[4] !== moreRecommendationsPromise || $[5] !== popupContainer || $[6] !== t6 || $[7] !== t7) {
    t8 = <ControlBarMoreAction contentKind={contentKind} moreRecommendationsPromise={moreRecommendationsPromise} popupContainer={popupContainer} buttonWrapperClassName={t6} buttonClassName={t7} showIcon={false} />;
    $[3] = contentKind;
    $[4] = moreRecommendationsPromise;
    $[5] = popupContainer;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t3 || $[10] !== t5 || $[11] !== t8) {
    t9 = <div className={t3}>{t5}{t8}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = `${isMobileLandscape ? "-rotate-90" : ""} size-4 shrink-0 text-vive-primary-20`;
  let t11;
  if ($[13] !== popupContainer || $[14] !== t10) {
    t11 = <ControlBarReportAction className="flex size-6 shrink-0 items-center justify-center rounded-full bg-white/15 p-1 backdrop-blur-[50px]" iconClassName={t10} popupContainer={popupContainer} reportModalContainer={popupContainer} />;
    $[13] = popupContainer;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t1 || $[17] !== t11 || $[18] !== t2 || $[19] !== t9) {
    t12 = <div data-component="mobile-control-bar" data-orientation={t1} className={t2}>{t9}{t11}</div>;
    $[16] = t1;
    $[17] = t11;
    $[18] = t2;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
}
export function createMobileControlBarViewportLayout({
  isMobileLandscape,
  moreRecommendationsPromise
}: ControlBarMobileViewportOptions): Omit<ControlBarViewportLayoutProps, 'children'> {
  return {
    barPlacement: 'before',
    className: isMobileLandscape ? 'flex h-full min-h-0 min-w-0 flex-1 flex-row' : 'flex h-full min-h-0 min-w-0 flex-1 flex-col',
    dataComponent: 'mobile-control-bar-layout',
    dataOrientation: isMobileLandscape ? 'landscape' : 'portrait',
    renderControlBar: popupContainer => <MobileControlBar moreRecommendationsPromise={moreRecommendationsPromise} popupContainer={popupContainer} />,
    viewportDataComponent: 'mobile-control-bar-viewport'
  };
}